export default function Footer() {
	return (
		<div className="flex justify-center items-center h-20 bg-black text-white">
			<p>&copy; 2021 タンポポラメン</p>
		</div>
	);
}
